export default {
  error: 'Error {statusCode}',
  message: '¡Oh no! Parece que no tienes los permisos para acceder a esta sección',
  back: 'Volver al inicio'
}

export const en = {
  error: 'Error {statusCode}',
  message: '¡Oh no! Parece que no tienes los permisos para acceder a esta sección',
  back: 'Volver al inicio'
}

export const ca = {
  error: 'Error {statusCode}',
  message: '¡Oh no! Parece que no tienes los permisos para acceder a esta sección',
  back: 'Volver al inicio'
}
